import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      activeName: this.$route.query.active || '1',
      tabs: [{
        comp: function comp() {
          return import('./component/template.vue');
        },
        active: '1',
        text: 'pay_slip_1' // 工资条模板
      }, {
        comp: function comp() {
          return import('./component/due-out.vue');
        },
        active: '2',
        text: 'pay_slip_2' // 待发工资条
      }, {
        comp: function comp() {
          return import('./component/issued.vue');
        },
        active: '3',
        text: 'pay_slip_3' // 已发工资条
      }],

      // 方案列表
      wageList: [],
      year: ''
    };
  },
  methods: {
    // 跳转下载工资条页面
    goToDownload: function goToDownload() {
      this.$router.push({
        path: 'download-pay-slip'
      });
    },
    // 工资条安全性
    goToSafe: function goToSafe() {
      this.$router.push({
        path: 'safe-pay-slip'
      });
    },
    goToDetail: function goToDetail(item, state) {
      // 跳转配置页
      this.$router.push({
        path: '/payroll/edit-pay-slip',
        query: {
          state: state
        }
      });
    }
  }
};